import * as React from 'react';
export function Button(props) {
    return (React.createElement("div", { className: "empori-buttons-container element-flex ".concat(props.alignment) },
        React.createElement("button", { className: "empori-button ".concat(props.style), title: props.title, onClick: props.onClick },
            props.style === 'text-like' &&
                React.createElement("i", { className: "fa-regular fa-chevron-".concat(props.alignment === 'align-center' ? 'down' : 'right') }),
            props.label)));
}
